import { BaseApiService } from "@mirage/services/BaseApiService";
import { IEntityPageRequest } from "@shared/mirage/core/contracts/IEntityPageRequest";
import { IEntityPageResult } from "@shared/mirage/core/contracts/IEntityPageResult";
import { IEnforcementAppealsFilteringLists } from "@shared/publicportal/contracts/EnforcementAppealsFilteringLists";
import { IEnforcementAppealDetails } from "@shared/publicportal/contracts/IEnforcementAppealDetails";
import { IEAppeal } from "@shared/publicportal/entities/IEAppeal";
import { IEnforcementAppealsService } from "@shared/publicportal/services/IEnforcementAppealsService";

export default class EnforcementAppealsService extends BaseApiService implements IEnforcementAppealsService {
    constructor() {
        super("publicportal/enforcementAppeals");
    }
    async getEnforcementAppeals(): Promise<IEAppeal[]> {
        const response = await this.httpInstance().get("/");
        return response.data;
    }
    async pageRequest(pr: IEntityPageRequest): Promise<IEntityPageResult<IEAppeal>> {
        const response = await this.httpInstance().post("/pageRequest", pr);

        return response.data;
    }
    async getFilteringLists(): Promise<IEnforcementAppealsFilteringLists> {
        const existingFilters = sessionStorage.getItem("publicportal.EnforcementAppealsService.dictionaries");
        if (!existingFilters) {
            const response = await this.httpInstance().get("/filters");
            const filters = response.data;
            sessionStorage.setItem("publicportal.EnforcementAppealsService.dictionaries", JSON.stringify(filters));
            return filters;
        }
        return JSON.parse(existingFilters);
    }
    async getEnforcementAppealById(appealId: number): Promise<IEnforcementAppealDetails> {
        const response = await this.httpInstance().get(`/${appealId}`);
        return response.data;
    }
}
